import { getCountryCodeByIP } from '@api/index'
import { EU_COUNTRIES } from '@/helpers/constants'

export const isEUCountry = (countryCode = ''): boolean =>
  EU_COUNTRIES.some((country) => country === countryCode.toUpperCase())

export const getLocation = async (): Promise<string> => {
  try {
    const countryCode = await getCountryCodeByIP()
    return countryCode || ''
  } catch (e) {
    console.error('getLocation', e)
    throw e
  }
}
